import React from 'react';
import { IconProps } from '@navi/web-ui/lib/icons/types';
import styles from '@navi/web-ui/lib/icons/Icons.module.scss';
import { getSvgDimensions } from '@navi/web-ui/lib/icons/utils';
import { DEFAULT_ICON_SIZE } from '@navi/web-ui/lib/icons/constants';

const AnimatedIcon: React.FC<IconProps> = ({
  size = DEFAULT_ICON_SIZE,
  width,
  height,
  color = styles.naviIconDefaultColor,
  fill = 'var( --blue-base)',
  ...restProps
}) => {
  const { svgHeight, svgWidth } = getSvgDimensions({ height, width, size });

  return (
    <svg
      width={svgWidth}
      height={svgHeight}
      viewBox="0 0 20 20"
      fill="none"
      className={styles.animatedSvg} // Add your custom class for styling
      {...restProps}
    >
      <path
        d="M17 10C17.5523 10 18.0064 9.55055 17.9376 9.00258C17.7832 7.77376 17.3449 6.59275 16.6518 5.55544C15.7727 4.23984 14.5233 3.21446 13.0615 2.60896C11.5997 2.00346 9.99113 1.84504 8.43928 2.15372C6.88743 2.4624 5.46197 3.22433 4.34315 4.34315C3.22433 5.46197 2.4624 6.88743 2.15372 8.43928C1.84504 9.99113 2.00346 11.5997 2.60896 13.0615C3.21446 14.5233 4.23985 15.7727 5.55544 16.6518C6.59275 17.3449 7.77376 17.7832 9.00258 17.9376C9.55055 18.0064 10 17.5523 10 17C10 16.4477 9.54924 16.0085 9.00461 15.9169C8.17213 15.7768 7.37471 15.462 6.66658 14.9888C5.67988 14.3295 4.91085 13.3925 4.45672 12.2961C4.0026 11.1997 3.88378 9.99334 4.11529 8.82946C4.3468 7.66557 4.91824 6.59647 5.75736 5.75736C6.59647 4.91824 7.66557 4.3468 8.82946 4.11529C9.99334 3.88378 11.1997 4.0026 12.2961 4.45672C13.3925 4.91085 14.3295 5.67988 14.9888 6.66658C15.462 7.37471 15.7768 8.17213 15.9169 9.00461C16.0085 9.54924 16.4477 10 17 10Z"
        fill={fill}
      />
    </svg>
  );
};

export default React.memo(AnimatedIcon);
